import styled from 'styled-components';

import { fonts, Link } from '@dreryk/react-components';

export const HealthcareTreeItemUpdateLink = styled(Link)`
   font-weight: ${fonts.fontWeightBold};
`;

HealthcareTreeItemUpdateLink.displayName = 'HealthcareTreeItemUpdateLink';
